
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/includes15/login",
      function () {
        return require("private-next-pages/includes15/login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/includes15/login"])
      });
    }
  